import { DesignOptions } from "@scenes/explore/utils/types";
import { useNavigationMenuSlice } from "@redux/slices/navigationMenuSlice";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { useTranslation } from "react-i18next";

const filterAndSortByPriceMode = (
  items: any[] = [],
  priceMode: number
): any[] =>
  [...items]
    .filter((item: any) =>
      item?.price_modes ? item?.price_modes?.includes(priceMode) : true
    )
    .sort(
      (itemFirst: any, itemSecond: any) => itemFirst.order - itemSecond.order
    )
    .map((item: any) =>
      item?.options
        ? {
            ...item,
            options: filterAndSortByPriceMode(item.options, priceMode),
          }
        : item
    );

const useProductArray = () => {
  const { getFilterData } = useNavigationMenuSlice();
  const filteredSections = getFilterData("search");
  const userInfo = useUserInfo();
  const { t } = useTranslation();
  const priceMode = userInfo.user.price_mode;

  const getTabsFilterData = (
    filteredArray: Array<any>,
    searchText: string
  ): Array<any> => {
    const tabFilteredArray = filteredArray.filter(
      (item) => item.type === searchText
    );

    return tabFilteredArray;
  };

  const tabFilterArray = getTabsFilterData(
    filteredSections[0].sub_section,
    DesignOptions.tabs
  );

  const tabOptionsFilterArray = getTabsFilterData(
    tabFilterArray[0].sub_section,
    DesignOptions.nav_option
  );

  const sortedSections = filterAndSortByPriceMode(
    tabOptionsFilterArray[0].options,
    priceMode
  );

  const productArray = sortedSections
    .filter(
      (item) =>
        userInfo?.getAllowedStockTypes()?.includes(item.name) &&
        item?.price_modes?.includes(priceMode)
    )
    .map((item, index) => {
      return {
        id: index,
        productType: item.name,
        title: t(item.label),
        icon: item.icon.data,
        type: item.icon.type,
        component: item?.component ?? "",
        iframeUrl: item?.iframeUrl ?? "",
        skipFilterScreenForWeb: item.skipFilterScreenForWeb ?? false,
        showFiltersOnStepTwo: item.show_filters_on_step_two ?? false,
        productColor: item?.icon?.icon_color,
        sectionName: item?.sectionName,
        hideSectionOnSplitScreen: item?.hideSectionOnSplitScreen ?? false,
        labelColor: item?.label_color,
        productPrefix: item?.productPrefix,
        options: item?.options || [],
        collection: item?.collection ?? "",
        is_collection: item?.is_collection ?? false,
        displaySubmenu: item?.displaySubmenu ?? false,
        deeplink: item?.deeplink,
        displayTabs: item?.displayTabs ?? false,
        hasSubOptions: item?.has_sub_options ?? false,
      };
    });

  const skipFilterScreen = (productType: string) => {
    const productObject = productArray.find(
      (_item) => _item.productType === productType
    );
    return productObject?.skipFilterScreenForWeb;
  };

  const showFiltersOnStepTwo = (productType: string) => {
    const productObject = productArray.find(
      (_item) => _item.productType === productType
    );
    return productObject?.showFiltersOnStepTwo;
  };

  const hideSectionOnSplitScreen = (productType: string) => {
    const productObject = productArray.find(
      (_item) => _item.productType === productType
    );
    return productObject?.hideSectionOnSplitScreen;
  };

  return {
    productArray,
    skipFilterScreen,
    showFiltersOnStepTwo,
    hideSectionOnSplitScreen,
  };
};

export default useProductArray;
